function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("polygon", {
  className: "st0",
  points: "113.8,56.9 113.8,35.6 105.1,56.9  "
}), React.createElement("path", {
  className: "st0",
  d: "M87,28.5c-0.9-0.3-2.7-0.4-5.5-0.4h-3.7v17.7H82c3,0,5-0.3,6-1c1-0.7,1.8-1.7,2.4-3.1c0.6-1.4,0.9-3,0.9-4.9 c0-2.3-0.4-4.1-1.2-5.6C89.2,29.8,88.2,28.9,87,28.5z"
}), React.createElement("path", {
  className: "st0",
  d: "M128.3,5.2H21.7c-9.3,0-16.9,7.6-16.9,16.9v52c0,9.3,7.6,16.9,16.9,16.9h106.5c9.3,0,16.9-7.6,16.9-16.9v-52 C145.2,12.7,137.6,5.2,128.3,5.2z M62.6,80h-7.1V30.8L48,80h-7.3l-7.5-49.1V80h-7.1V17.6h11.4l6.9,42.6l6.8-42.6h11.4V80z  M94.6,52.6c-1.3,1.5-2.6,2.5-4,3c-1.8,0.6-4.5,0.9-7.9,0.9h-5V80h-7.6V17.6h12.2c4.6,0,7.7,0.3,9.1,0.9c2.2,0.9,4,3,5.4,6.1 c1.5,3.1,2.2,7.2,2.2,12.2c0,3.8-0.4,7.1-1.3,9.7C97,49,95.9,51.1,94.6,52.6z M125.5,67.4h-4.7V80h-7V67.4H98.3V56.9l16.4-39.6h6.1 v39.6h4.7V67.4z"
}));

var SvgMp4Icon = function SvgMp4Icon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 98.8",
    style: {
      enableBackground: "new 0 0 150 98.8"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMp4Icon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mp4-icon.9ee0f392.svg";
export { ForwardRef as ReactComponent };